<template>
  <module-page v-bind="pageParams">
    <v-layout row wrap v-for="image in stockImages" :key="image.url">
      <v-flex xs12>
        <v-card class="credits__card" outlined tile>
          <div class="credits__card-container">
            <v-img
              @click="openImageStock(image)"
              class="credits__img-container"
              :src="image.thumbnail"
            >
            </v-img>

            <div class="credits__card-container-description">
              <div class="credits__card-container-title">
                <h2>{{ image.title }}</h2>
              </div>

              <p>{{ image.url }}</p>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </module-page>
</template>

<script>
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import { APP } from '@/utils/constants';
export default {
  name: 'credits',
  components: {
    ModulePage,
    ScreenLoading,
  },
  computed: {},
  data() {
    return {
      stockImages: [
        {
          url: 'https://br.freepik.com/fotos-premium/familia-relaxante-sofa_2177652.htm',
          thumbnail:
            'https://image.freepik.com/fotos-gratis/familia-relaxante-sofa_23-2147800085.jpg',
          title: 'Login',
        },
        {
          url: 'https://br.freepik.com/fotos-gratis/casal-alegre-com-notebook-no-sofa_1868249.htm',
          thumbnail:
            'https://image.freepik.com/fotos-gratis/casal-alegre-com-notebook-no-sofa_23-2147766956.jpg',
          title: 'Banner',
        },
        {
          url: 'https://www.123rf.com/photo_41581869_family-taking-photo-of-themselves.html',
          thumbnail:
            'https://previews.123rf.com/images/piksel/piksel1506/piksel150600075/41581869-family-taking-photo-of-themselves.jpg',
          title: 'Email',
        },
        {
          url: 'https://br.freepik.com/fotos-gratis/imagem-de-objetos-de-engenharia-na-visao-superior-do-local-de-trabalho-conceito-de-construcao-ferramentas-de-engenharia-tom-padrao-de-filtro-retroiluminado-foco-suave-foco-seletivo_1238636.htm',
          thumbnail:
            'https://image.freepik.com/fotos-gratis/imagem-de-objetos-de-engenharia-na-visao-superior-do-local-de-trabalho-conceito-de-construcao-ferramentas-de-engenharia-tom-padrao-de-filtro-retroiluminado-foco-suave-foco-seletivo_1418-474.jpg',
          title: 'Admin',
        },
      ],
    };
  },
  created() {
    this.pageParams = this.$store.getters[APP.PAGES].credits;
  },
  methods: {
    openImageStock(image) {
      const title = image.title;
      const url = image.url;

      this.createTrace(this.enums.logTraceActions.imageStockLink, {
        title,
        url,
      });
      window.open(image.url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.credits {
  @include breakpoint(mobile) {
    &__card-container {
      flex-direction: column;
    }

    &__card-container-description {
      width: auto !important;
    }
  }

  &__card {
    margin: 6px 0;
  }
  &__card-container {
    display: flex;
  }

  &__card-container-description {
    padding: 12px;
    width: calc(100% - 320px);
  }

  &__card-container-title {
    h2 {
      display: inline-block;
    }
    span {
      float: right;
    }
  }

  &__img-container {
    min-width: 320px;
    min-height: 180px;

    &:hover {
      opacity: 0.5;
      cursor: pointer;
    }

    .play {
      position: relative;
      top: 50%;
      left: 50%;
      width: 80px;
      height: 80px;
      margin: -40px 0 0 -40px;
    }
  }

  &__video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/app/Credits.vue